module.exports = __webpack_public_path__ + "images/company_profile/icon09-757e1b847b9ae9bc5a291985f920e238.png";